import { coinsVaultModel } from '@models/coins.vault.model';
import { normalizeSuiCoinType } from '@utils/index';
import { useModel } from 'foca';
import { useEffect, useState } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';

export const useInitVaultCoins = () => {
  const [coins, setCoins] = useState<OpenapiClientParrotVault.GetVaultCoinsResponse>();
  const initCoins = async () => {
    try {
      const result = await coinsVaultModel.getCoins();
      setCoins(result);
      return true;
    } catch (err) {
      setCoins(undefined);
    }
    return false;
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = async () => {
      const isLoading = await initCoins();
      if (isLoading) {
        timer = setTimeout(() => {
          loop();
        }, 300_000); // 5 minutes
      }
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return coins;
};

export const useVaultCoins = () => {
  const coins = useModel(coinsVaultModel, (state) => state.cacheCoins);
  return { coins };
};

export const useVaultCoin = (coinType: string | undefined) => {
  const type = coinType ? normalizeSuiCoinType(coinType) : '';
  const coin = useModel(coinsVaultModel, (state) => state.coins[type]);

  // useEffect(() => {
  //   !coin && !!type && coinsVaultModel.getCoin(type);
  // }, [type, coin]);

  return { coin };
};
